export default {
  HEADING: 'Nehmen Sie\nKontakt auf!',
  PHONE: '030 47 37 535 0',
};
